//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';

// === API ===
import {userEdit} from 'api/prokey/prokey.websocket';

// === STYLES ===
import { useTheme } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Checkbox,
  FormControlLabel,
} from '@mui/material';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

//#endregion

const settings_default = {
  allowManualTaskSelection: false,
}

//-----------------------------------------------------------------
function EditUserDialog(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user } = props;

  const theme = useTheme();

  const [ firstName , setFirstName] = useState( user.FirstName );
  const [ lastName  , setLastName ] = useState( user.LastName  );
  const [ username  , setUsername ] = useState( user.Username  );
  const [ email     , setEmail    ] = useState( user.Email     );
  const [ company   , setCompany  ] = useState( user.Company   );
  const [ settings  , setSettings ] = useState( { ...settings_default, ...user.Settings } );

  const [ show_alert , setShowAlert ] = useState( false );
  const [ alert_text , setAlertText ] = useState( '' );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      // backgroundColor: theme.palette.primary.main + getHexAlpha(20),
    }
  }

  const
    CONTAINER = {
      sx : _styles.container,
    },
    DIALOG = {
      sx : _styles.container,
      open           : props.showDialog,
      onClose        : handleClose,
      'aria-labelledby' : 'form-dialog-title'
    },
    FIRST_NAME = {
      id           : 'first-name',
      label        : 'First Name',
      value        :  firstName,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setFirstName(e.target.value); },
      name         : 'edit_user_first_name_input',
    },
    LAST_NAME = {
      id           : 'last-name',
      label        : 'Last Name',
      value        :  lastName,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setLastName(e.target.value); },
      name         : 'edit_user_last_name_input',
    },
    USERNAME = {
      id           : 'username',
      label        : 'Username',
      value        :  username,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setUsername(e.target.value); },
      name         : 'edit_user_username_input',
    },
    EMAIL = {
      id           : 'email',
      label        : 'Email',
      value        :  email,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setEmail(e.target.value); },
      name         : 'edit_user_email_input',
    },
    COMPANY = {
      id           : 'company',
      label        : 'Company',
      value        :  company,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setCompany(e.target.value); },
      name         : 'edit_user_company_input',
    },
    TASK_SELECTION = {
      checked: settings.allowManualTaskSelection,
      onChange: (e) => {
        const temp = { ...settings };
        temp.allowManualTaskSelection = !settings.allowManualTaskSelection;
        setSettings( temp );
      },
    },
    BUTTON_CLOSE = {
      color    : 'primary'   ,
      onClick  : handleClose ,
      children : [ 'Close' ] ,
      name     : 'close_edit_user_dialog_btn',
    },
    BUTTON_SUBMIT = {
      color    : 'primary'    ,
      onClick  : handleSubmit ,
      children : [ 'Submit' ] ,
      name     : 'submit_edit_user_dialog_btn',
    };

  //#endregion

  //#region [EFFECT]



  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function editUser() {
    //-----------------------------------------------------------------
    try {
      // Check form, make sure we have all the data we want and it's well formatted
      let error_text = '';
      if ( !firstName ) error_text += ', First Name must be filled'   ;
      if ( !lastName  ) error_text += ', Last Name must be filled'    ;
      if ( !username  ) error_text += ', Username must be filled'     ;
      if ( !email     ) error_text += ', Email must be filled'        ;
      if ( !company   ) error_text += ', Company Name must be filled' ;
  
      if (error_text) {
        setAlertText(error_text.substring(2));
        setShowAlert(true);
        return false;
      }
  
      // Submit data to backend api
      let user_data = {
        firstName ,
        lastName  ,
        username  ,
        email     ,
        company   ,
        settings  ,
      };

      userEdit(user.Id, user_data)     
      
      return true;
    } catch (error) {
      console.log( error );
    }
  }

  //-----------------------------------------------------------------
  function resetData() {
    //-----------------------------------------------------------------
    setFirstName ( user.FirstName );
    setLastName  ( user.LastName  );
    setUsername  ( user.Username  );
    setEmail     ( user.Email     );
    setCompany   ( user.Company   );
    setSettings  ( { ...settings_default, ...user.Settings } );
  };

  //-----------------------------------------------------------------
  function handleSubmit( event ) {
    //-----------------------------------------------------------------
    const is_success = editUser();
    if( is_success ) props.setShowDialog(false);
  };

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowDialog(false);
    handleDismissAlert();
    resetData();
  };

  //-----------------------------------------------------------------
  function handleDismissAlert() {
    //-----------------------------------------------------------------
    setShowAlert(false);
    setAlertText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT

  //-----------------------------------------------------------------
  function handleErrClose(event, reason) {
    //-----------------------------------------------------------------
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };

  //-----------------------------------------------------------------
  function displayError() {
    //-----------------------------------------------------------------
    return (
      <Snackbar open={show_alert} autoHideDuration={6000} onClose={handleErrClose}>
        <Box>
          <Alert onClose={handleErrClose} severity='error'>
            {alert_text}
          </Alert>
        </Box>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  //-----------------------------------------------------------------
  function displayAddUserModal() {
    //-----------------------------------------------------------------
    if( !props.showDialog ) return null;

    return (
      <div { ...CONTAINER } >
        <Dialog { ...DIALOG } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >Edit User</DialogTitle>
          <DialogContent sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
            <DialogContentText>Enter user information</DialogContentText>
            <TextField { ...USERNAME   } />
            <TextField { ...FIRST_NAME } />
            <TextField { ...LAST_NAME  } />
            <TextField { ...EMAIL      } />
            <TextField { ...COMPANY    } />
            <FormControlLabel 
              label   = "Allow Manual Task Selection" 
              control = { <Checkbox { ...TASK_SELECTION } nane='allow_manual_task_selection_chk' /> }
            />
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
            <Button { ...BUTTON_CLOSE  } />
            <Button { ...BUTTON_SUBMIT } />
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    );
  }

  //#endregion

  return displayAddUserModal();
}

export { EditUserDialog };
